<template>
  <div>
    <el-dialog center title="入库凭证上传" :visible.sync="dialogVisible" width="700px" destroy-on-close>
      <el-upload
        class="upload-demo"
        drag
        accept="png,jpg,jpeg"
        action=""
        :limit="limit"
        :http-request="e => uploadFile(e, purchaseId)"
        :on-preview="preView"
        :before-remove="remove"
        :on-exceed="exceed"
        multiple
        show-file-list
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="primary" plain style="width: 80px">取 消</el-button>
        <el-button type="primary" @click="submit" style="width: 80px">确 定</el-button>
      </span>
    </el-dialog>
    <image-viewer
      :z-index="99999999999"
      :initial-index="0"
      v-if="dialogVisibleImg"
      :on-close="closeViewer"
      :url-list="imgUrls"
    />
  </div>
</template>

<script>
import imageViewer from '@/components/image-viewer';
export default {
  components: { imageViewer },
  props: ['limit', 'purchaseId'],
  data() {
    return {
      dialogVisible: false,
      dialogVisibleImg: false,
      imgUrls: [],
      showViewer: false,
      fileList: []
    };
  },
  methods: {
    async uploadFile(e, purchaseId) {
      const { storeId } = this;
      const file = e.file;
      const fd = new FormData();
      fd.append(
        'uploadParam',
        JSON.stringify({
          appName: 'amikacin-pic',
          scene: 'license_file',
          bizFileName: `license_file/${e.file.name}`,
          fileName: `license_file/${e.file.name}`
        })
      );
      fd.append('fileStream', file);
      const {
        data: { resId, ...res }
      } = await Fetch.uploadImage(fd);

      console.log(e.file);
      this.fileList.push({
        resId,
        uid: e.file.uid
      });

      // await Fetch.pc_upload_offline_prescription({ storeId, orderId, prescriptionFileId: resId, orderDetailId });

      // this.$emit('update', orderDetailId);
    },
    submit() {
      this.$emit(
        'submit',
        this.fileList.map(item => item.resId)
      );
    },
    exceed() {
      this.$message.error('超出文件上传数量');
      return false;
    },
    preView(file) {
      this.dialogVisibleImg = true;
      this.imgUrls = [
        {
          url: URL.createObjectURL(file.raw),
          uploadTime: ''
        }
      ];
    },
    closeViewer() {
      this.dialogVisibleImg = false;
    },
    remove(file, fileList) {
      this.closeViewer();
      const idIndex = this.fileList.findIndex(item => item.uid == file.raw.uid);
      this.fileList.splice(idIndex, 1);
    }
  }
};
</script>

<style scoped>
.upload-demo {
  margin-left: 100px;
  padding-bottom: 40px;
}
</style>
